<template>
  <div class="manage_pup">
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      v-loading = "loading"
      center
      :title="title"
      :visible.sync="dialogVisible"
      width="700px"
    >
      <div
        style="
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: space-between;
        "
      >
        <div class="right_form">
          <el-form
            ref="form"
            label-position="right"
            :model="form"
            label-width="90px"
          >
            <el-form-item
              label="姓名:"
              prop="xm"
              :rules="{
                required: true,
                trigger: ['blur', 'change'],
                message: '请选择',
              }"
            >
              <el-select
                v-model="form.xm"
                filterable
                placeholder=""
                style="width: 100%"
                @change="xxyChange"
              >
                <el-option
                  v-for="(item, index) in xxyList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="证件号码:">
              <el-input v-model="form.zjhm" disabled />
            </el-form-item>
            <el-form-item
              label="手机号码:"
              prop="sjh"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  validateMobile(rule, value, callback, 'bt');
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input v-model="form.sjh" />
            </el-form-item>
            <el-form-item label="验证码:">
              <el-input
                v-model="form.yzm"
                style="width: 228px; margin-right: 10px"
                placeholder="请输入验证码"
                autocomplete="off"
              />
              <el-button
                v-preventReClick
                style="background-color: #4170ff; border: none"
                type="primary"
                @click="getcode"
              >{{ codetime }}</el-button>
            </el-form-item>
          </el-form>
          <div style="color: red; margin: auto; text-align: center">
            密码默认'yzd@'+手机号后四位（如'yzd@4321'）
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button v-preventReClick @click="addgly(0)">取消</el-button>
        <el-button
          v-preventReClick
          type="primary"
          style="background: #4170ff; border: none; margin-left: 30px"
          @click="addgly(1)"
        >保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { sendYzm, dwcxxySave, getCyryxx } from '@/assets/js/manage.js'
import { validateMobile } from '@/assets/js/validate.js'
export default {
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      xxyList: [],
      // 获取验证码
      codetime: '验证码',
      title: '新增次级管理员',
      dialogVisible: false,
      form: {
        zjhm: '',
        sjh: '',
        xm: '',
        yzm: ''
      }
    }
  },
  watch: {
    dialogVisible(newValue, oldValue) {
      if (newValue == true) {
        this.form = {
          zjhm: '',
          sjh: '',
          xm: '',
          yzm: ''
        }
        getCyryxx().then((e) => {
          this.xxyList = e.data.data
        });
      }
    }
  },
  mounted() {},
  methods: {
    validateMobile,
    xxyChange(val) {
      this.xxyList.filter((item, index) => {
        if (item.value == val) {
          this.form.zjhm = item.zjhm
          this.form.sjh = item.sjhm
          this.form.id = item.value
        }
      })
    },
    // 获取验证码
    getcode() {
      var that = this
      if (this.codetime == '验证码') {
        sendYzm(this.form.sjh).then((e) => {
          var time = 60
          this.codetime = 60
          var t = setInterval(function() {
            if (time == 0) {
              that.codetime = '验证码'
              clearInterval(t)
            } else {
              time--
              that.codetime = time
            }
          }, 1000)
        })
      }
    },
    // 添加
    addgly(type) {
      var that = this
      if (type == 0) {
        that.dialogVisible = false
      } else if (type == 1) {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$confirm('此操作将新增次级管理员, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                this.loading = true
                dwcxxySave({
                  id: this.form.id,
                  sjhm: this.form.sjh,
                  yzm: this.form.yzm
                }).then((e) => {
                  this.loading = false
                  if (e.data.code == '000000') {
                    that.dialogVisible = false
                    this.$emit('refresh')
                    this.$message({
                      type: 'success',
                      message: '添加成功!'
                    })
                  }
                }).catch((error) => {
                  this.loading = false
                })
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消删除'
                })
              })
          }
        })
      }
    }
  }
}
</script>
<style scoped lang='less'>
.manage_pup {
  /deep/.el-dialog__header {
    padding: 40px 20px 10px !important;
    .el-dialog__title {
      width: 120px;
      height: 28px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #434343;
      line-height: 28px;
    }
    .el-dialog__close {
      color: #000000 !important;
      font-weight: bold;
    }
  }
  .left_img {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    .card_img_item {
      display: flex;
      flex-direction: column;
      align-items: center;
      span {
        margin-top: 10px;
        height: 18px;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #636363;
        line-height: 18px;
      }
    }
    .card_img_item:nth-child(1) {
      margin-bottom: 60px;
    }
  }
  .right_form {
    width: 410px;
    margin-left: auto;
    margin-right: auto;
    // .el-form {
    //   display: flex;
    //   flex-wrap: wrap;
    //   justify-content: space-between;
    // }
  }
}
</style>
